import axios from 'axios';
import Cookies from 'js-cookie';

const API_URL = `${process.env.REACT_APP_API_URL}`;

const refreshToken = async (refreshToken) => {
    try {
        const response = await axios.post(`${API_URL}/token/refresh/`, { refresh: refreshToken },
      {
        headers: {
          "X-CLIENT-API-KEY": process.env.REACT_APP_API_KEY,
        },
      });
        const accessToken = response.data.access;
        const newRefreshToken = response.data.refresh;
       
        Cookies.set('access_token',accessToken);
        Cookies.set('refresh_token',newRefreshToken);

        return accessToken;
    } catch (error) {
        console.error('Error refreshing token:', error);
        throw error;
    }
};

export default refreshToken;
